import api, { API_BASE } from "./api";

/** True when URL must be fetched with Authorization (not usable as raw href/src). */
export function isProtectedFileUrl(url) {
  if (!url || typeof url !== "string") return false;
  if (url.startsWith("data:")) return false;
  if (url.startsWith("blob:")) return false;
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url.includes("/api/");
  }
  return url.startsWith("/api/");
}

function toApiPath(url) {
  if (!url) return "";
  if (url.startsWith(API_BASE)) {
    return url.slice(API_BASE.length) || "/";
  }
  if (url.startsWith("/api/")) {
    return url.slice(4);
  }
  return url;
}

/** Resolve display URL: data/http as-is; API paths fetched with auth → blob URL. */
export async function resolveFileUrl(url) {
  if (!url) return null;
  if (!isProtectedFileUrl(url)) return url;
  const path = toApiPath(url);
  const res = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(res.data);
}

export async function fetchProtectedBlob(url) {
  const path = toApiPath(url);
  const res = await api.get(path, { responseType: "blob" });
  return res.data;
}

export async function openProtectedFile(url) {
  const blobUrl = await resolveFileUrl(url);
  if (!blobUrl) return;
  window.open(blobUrl, "_blank", "noopener,noreferrer");
  if (blobUrl.startsWith("blob:")) {
    setTimeout(() => URL.revokeObjectURL(blobUrl), 120000);
  }
}

export async function downloadProtectedFile(url, fileName) {
  const blobUrl = await resolveFileUrl(url);
  if (!blobUrl) return;
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = fileName || "download";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  if (blobUrl.startsWith("blob:")) {
    setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
  }
}

/** Upload employee document to disk (multipart). */
export async function uploadEmployeeDocument(employeeId, file, { name, expiryDate, companyId } = {}) {
  const form = new FormData();
  form.append("file", file);
  form.append("name", name || file.name || "Document");
  if (expiryDate) form.append("expiry_date", expiryDate);
  if (companyId) form.append("company_id", companyId);
  const res = await api.post(`/employees/${employeeId}/documents`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

/** Upload company logo to disk (multipart). */
export async function uploadCompanyLogo(companyId, file) {
  const form = new FormData();
  form.append("file", file);
  const res = await api.post(`/company/${companyId}/logo`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}
